import styled from 'styled-components';

export const SLoadMoreWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin: 20px 0;
`;
